module.exports = __webpack_public_path__ + "img/sanoj.f2a56e12.png";